const filterSuggestions = (suggestions, enteredValue) => {
    const results = suggestions.filter((suggestion) => suggestion.toLocaleLowerCase().includes(enteredValue.toLocaleLowerCase()));
    return results.length === 1 &&
        results[0].toLocaleLowerCase() === enteredValue.toLocaleLowerCase()
        ? []
        : results;
};
export default filterSuggestions;
//# sourceMappingURL=filterSuggestions.js.map